var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGlobeOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 2.49986C5.85778 2.49986 2.49992 5.85772 2.49992 9.99986C2.49992 14.142 5.85778 17.4999 9.99992 17.4999C14.1421 17.4999 17.4999 14.142 17.4999 9.99986C17.4999 5.85772 14.1421 2.49986 9.99992 2.49986ZM0.833252 9.99986C0.833252 4.93725 4.93731 0.833191 9.99992 0.833191C15.0625 0.833191 19.1666 4.93725 19.1666 9.99986C19.1666 15.0625 15.0625 19.1665 9.99992 19.1665C4.93731 19.1665 0.833252 15.0625 0.833252 9.99986Z",
    fill: "#3456FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833252 10.0001C0.833252 9.53991 1.20635 9.16681 1.66659 9.16681H18.3333C18.7935 9.16681 19.1666 9.53991 19.1666 10.0001C19.1666 10.4604 18.7935 10.8335 18.3333 10.8335H1.66659C1.20635 10.8335 0.833252 10.4604 0.833252 10.0001Z",
    fill: "#3456FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50011 10.0004C7.55722 12.5628 8.43846 15.0297 9.99992 17.0414C11.5614 15.0297 12.4426 12.5628 12.4997 10.0004C12.4426 7.43803 11.5614 4.9711 9.99992 2.95939C8.43846 4.9711 7.55722 7.43803 7.50011 10.0004ZM9.99992 1.66706L9.38463 1.10504C7.164 3.53615 5.90201 6.69111 5.83343 9.98304C5.83319 9.99461 5.83319 10.0062 5.83343 10.0178C5.90201 13.3097 7.164 16.4646 9.38463 18.8957C9.54251 19.0686 9.76582 19.1671 9.99992 19.1671C10.234 19.1671 10.4573 19.0686 10.6152 18.8957C12.8358 16.4646 14.0978 13.3097 14.1664 10.0178C14.1666 10.0062 14.1666 9.99461 14.1664 9.98304C14.0978 6.69111 12.8358 3.53615 10.6152 1.10504L9.99992 1.66706Z",
    fill: "#3456FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobeOutline);
export default __webpack_public_path__ + "static/media/icon-globe-outline.2416b1e44828dcd5f9e3d979d89af323.svg";
export { ForwardRef as ReactComponent };